import controlBasket from "./Cart";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  controlBasket,
});

export default rootReducer;
